import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'pTTotal';

export const config = (labels) =>
	numberColumnConfig({
		id: 'gaTotalForms',
		label: labels.groupAuditTotalForms,
		prop,
		width: 'minmax(var(--px-150), 1fr)'
	});
